import type { Location } from 'history' 

export const getOnlyURLParams = (location: Location): string => {
  const query = new URLSearchParams(location.search)
  const urlRemove = ['code', 'session_state', 'code_challenge', 'state', 'sp', 'tenantDomain']
  const newQuery = new URLSearchParams()

  for (const urlParam of urlRemove) {
    query.delete(urlParam)
  }

  for (const key of query.keys()) {
    const value = query.get(key)
    if (value) {
      if (value.endsWith("/")) {
        // Remove barra do final da query se possuir
        newQuery.set(key, value.slice(0, -1))
      } else {
        newQuery.set(key, value)
      }
    }
  }

  return newQuery.toString()
}

